module.exports = __webpack_public_path__ + "static/img/tbg2.a3d80ed4.png";